import { Info, Instagram, LifeBuoy, MessageSquare, ShieldCheck } from 'lucide-react';
import { useI18n } from '../i18n';

interface FooterLinksProps {
  onFeedback?: () => void;
  className?: string;
}

const FooterLinks = ({ onFeedback, className = '' }: FooterLinksProps) => {
  const { locale, t } = useI18n();
  const linkClassName = 'inline-flex min-h-11 items-center gap-2 text-xs text-gray-500 transition-colors hover:text-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary-600 sm:min-h-7';

  return (
    <nav aria-label={t('footer_links_label')} className={`flex flex-wrap items-center gap-x-5 gap-y-1 ${className}`}>
      <a href={`https://dohockey.app/${locale}/about`} target="_blank" rel="noopener noreferrer" className={linkClassName}>
        <Info size={18} aria-hidden="true" className="shrink-0" />
        <span>{t('footer_about_link')}</span>
      </a>
      {onFeedback && (
        <button type="button" onClick={onFeedback} className={linkClassName}>
          <MessageSquare size={18} aria-hidden="true" className="shrink-0" />
          <span>{t('issue_form_button')}</span>
        </button>
      )}
      <a href={`https://dohockey.app/${locale}/privacy`} target="_blank" rel="noopener noreferrer" className={linkClassName}>
        <ShieldCheck size={18} aria-hidden="true" className="shrink-0" />
        <span>{t('footer_privacy_link')}</span>
      </a>
      <a href={`https://dohockey.app/${locale}/resources`} target="_blank" rel="noopener noreferrer" className={linkClassName}>
        <LifeBuoy size={18} aria-hidden="true" className="shrink-0" />
        <span>{t('footer_support_link')}</span>
      </a>
      <a href="https://www.instagram.com/dohockey.app/" target="_blank" rel="noopener noreferrer" aria-label={t('footer_instagram_label')} className={linkClassName}>
        <Instagram size={18} aria-hidden="true" className="shrink-0" />
        <span>{t('footer_instagram_link')}</span>
      </a>
    </nav>
  );
};

export default FooterLinks;
